import React from "react";
import { registerComponent } from "../../../lib/vulcan-lib/components";

import { useCurrentUser } from "../../common/withUser";
import { useUpdate } from "../../../lib/crud/withUpdate";
import { userCanDo } from "../../../lib/vulcan-users/permissions";
import { preferredHeadingCase } from "../../../themes/forumTheme";
import DropdownItem from "../DropdownItem";

const ShortformDropdownItem = ({post}: {post: PostsBase}) => {
  const currentUser = useCurrentUser();
  const {mutate: updateUser} = useUpdate({
    collectionName: "Users",
    fragmentName: 'UsersCurrent',
  });

  if (post.shortform || !userCanDo(currentUser, "posts.edit.all")) {
    return null;
  }

  const handleMakeShortform = () => {
    void updateUser({
      selector: {_id: post.userId},
      data: {
        shortformFeedId: post._id,
      },
    });
  }

  const contentType = preferredHeadingCase("Quick Takes");
  return (
    <DropdownItem
      title={preferredHeadingCase(`Set as user's ${contentType} Post`)}
      onClick={handleMakeShortform}
    />
  );
}

export default registerComponent(
  "ShortformDropdownItem",
  ShortformDropdownItem,
);


